module.exports = __webpack_public_path__ + "static/media/button-minus.7fddceba.svg";